import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconRadioIdle(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Z"
        fill="currentColor"
        fillOpacity=".4"
      />
    </BaseIcon>
  );
}
